export default "__VITE_ASSET__19f407e5__"